export default {
  overview: {
    padding: 10,
  },
  // tabPage: {
  //   padding: 10,
  // },
  // removeDate: {
  //   height: 30,
  //   padding: 0,
  // },
  // subRow: {
  //   display: 'flex',
  //   height: 30,
  //   verticalAlign: 'center',
  //   alignItems: 'center',
  // },
  // addTask: {
  //   top: 80,
  //   right: 20,
  //   position: 'fixed',
  //   zIndex: 2000,
  // },
  // generateLabelsIcon: {
  //   top: 80,
  //   right: 70,
  //   position: 'fixed',
  //   zIndex: 2000,
  // },
  // taskButtons: {
  //   textAlign: 'right',
  // },
  // taskStatusCol: {
  //   width: 80,
  // },
  // stageComplete: {
  //   color: 'green',
  // },
  // stagePending: {
  //   color: 'red',
  // },
  // actions: {
  //   position: 'fixed',
  //   bottom: 0,
  //   height: 50,
  //   backgroundColor: SECONDARY,
  //   left: 0,
  //   right: 0,
  //   textAlign: 'right',
  //   verticalAlign: 'center',
  //   paddingTop: 6,
  //   zIndex: 1000,
  // },
  // action: {
  //   color: 'white',
  // },
  // form: {
  // },
  // addStage: {
  //   margin: 5,
  // },
  // tagsHeader: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   marginTop: 10,
  // },
  // tagsLabel: {
  //   flex: 1,
  // },
  // bottomNav: {
  //   position: 'fixed',
  //   bottom: 50,
  //   height: 70,
  //   left: 150,
  //   right: 0,
  //   paddingTop: 6,
  //   zIndex: 1000,
  //   backgroundColor: PRIMARY,
  // },
  // bottomNavButton: {
  //   color: 'white',
  // },
  // generateLabel: {},
};



// WEBPACK FOOTER //
// ./src/components/Jobs/JobDialog/styles.js